import {
    AfterViewInit,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {TableColumnDef} from '../../../shared/tables/table-column-def';
import {FilterOutputModel, TableResponseQuery} from '../../../core';
import {Observable, of} from 'rxjs';
import {GeneralService, SnackbarService} from '../../../core';
import {ActivatedRoute, Router} from '@angular/router';
import {Table} from 'primeng/table';
import {BaseTable} from '../base-table';

@Component({
    selector: 'pr-new-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss', '../base-table.scss']
})
export class TableComponent extends BaseTable implements OnInit, AfterViewInit {

    @HostBinding('class') classes = 'flex flex-grow';

    @ViewChild('dt', {static: false}) dt: Table;

    @Input() dataService: any;
    @Input() sortBy: string;
    @Input() dataServiceMethod = 'fetchData';

    @Output()
    tableDataLoaded = new EventEmitter();

    @Output()
    tableCountLoaded = new EventEmitter();

    totalRecords = 0;
    tableData: any[] = [];
    isLoading = true;

    constructor(
        protected snackBar: SnackbarService,
        generalService: GeneralService,
        router: Router,
        activatedRoute: ActivatedRoute
    ) {
        super(router, generalService, activatedRoute);
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.setAllParameters();
        this.saveTableState();
    }

    clearGlobalFilter() {
        this.filterGlobalControl.reset();
        this.dt.filterGlobal('', 'contains');
    }

    loadData(event: any) {
        this.isLoading = true;

        let sort = this.sortBy;
        if (event.sortField !== undefined && event.sortField !== null) {
            const columnDef = this.columnsData.find(
                (c: TableColumnDef) => c.columnDef === event.sortField
            );
            sort = ((columnDef.sortColumnDef) ? columnDef.sortColumnDef : event.sortField) + (event.sortOrder === 1 ? ' asc' : ' desc');
        }

        let filters: FilterOutputModel[] = [];
        if (event.filters !== undefined && event.filters !== null) {
            filters = Object.keys(event.filters)
                .filter(e => e !== 'global')
                .map((e) =>
                    <FilterOutputModel>{
                        filterValues: [event.filters[e].value],
                        columnDef: this.columnsData.find(
                            (c: TableColumnDef) => c.columnDef === e
                        ),
                    }
                );
        }

        this.dataService[this.dataServiceMethod](
                event.rows,
                event.first,
                sort,
                event.globalFilter,
                filters
            )
            .subscribe(
                (d: TableResponseQuery) => {
                    this.tableData = d.items;
                    this.totalRecords = d.total_count;
                    this.tableCountLoaded.emit(this.totalRecords);
                    this.tableDataLoaded.emit(this.tableData);
                    this.isLoading = false;
                },
                (error: any) => {
                    console.log('TableComponentError', error);
                    this.isLoading = false;
                    this.messageOnFetchData(error);
                },
                () => {
                    this.isLoading = false;
                }
            );

        this.clearStateFromFilters();
    }

    reloadTable() {
        this.loadData(this.dt.createLazyLoadMetadata());
    }

    protected messageOnFetchData(error): Observable<TableResponseQuery> {
        if (error.status !== 403) {
            this.snackBar.info('Wystąpił problem podczas pobierania danych.');
        }
        return of(new TableResponseQuery([], 0));
    }
}
